<ng-container *ngIf='!accessDenied'>
    <div *ngIf="!loader" class="w-100 float-left">
        <div class="w-100 float-left v-align relative" *ngIf='mainPage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0">TARGET</h5>
                <div style="flex-grow: 1;"></div>
                <button id="add" (click)="addCorTarget($event)" class="btn btn-primary float-right mr-3"> Add Cor
                    Target
                </button>
                <!-- <button id="add" (click)="onBack()" class="btn btn-primary float-right mr-3"> Back </button> -->
            </div>

        </div>
        <div *ngIf='mainPage' class="main-table table-custom">
            <div class="w-100 float-left p-3 light-bg">
                <div class="form-group">
                    <div class='col-lg-12 col-md-12 left-clear'>
                        <label>
                            <h5 class="medium m-0">Data Operations</h5>
                        </label>
                    </div>
                </div>
                <div class="form-group">
                    <div class='col-lg-12 col-md-12 left-clear'>
                        <form enctype="multipart/form-data" method="POST" class="">
                            <input type="file" accept=".xls,.xlsx" class="pull-left next-btn r mt-smd m-r-smd m-b-smd"
                                   multipart=true name="file" #file (change)="fileChange($event)"
                                   placeholder="No File Chosen."/>
                            <button id="bulkUpload" type="submit" class="btn btn-primary float-right mr-3"
                                    (click)="bulkUpload($event)">Bulk Upload
                            </button>
                        </form>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left mt-3 light-bg">
                <div class="col-lg-10 col-md-12 col-sm-12 col-xs-12 float-left p-2 align-v-center">
                    <input class="w-50 float-left form-control" name="searchBox" id="searchBox" #searchBox
                           maxlength="100" placeholder="Keywords"
                           type="text" ng-reflect-maxlength="100" ng-reflect-model="" [(ngModel)]="trgReg">
                    <div>
                        <button id="Search" (click)="searchPTarget()" class="btn btn-primary float-left">Search</button>
                    </div>
                </div>
            </div>

            <div class="w-100 float-left mt-3">
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Target Code">
                        <h6 class="mb-lg-0 medium text-truncate"> Target Code </h6>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Target Name">
                        <h6 class="mb-lg-0 medium text-truncate"> Target Name </h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center" ngbTooltip="Actions">
                        <h6 class="mb-lg-0 medium text-truncate"> Actions </h6>
                    </div>
                </div>
            </div>
            <div class="w-100 float-left p-md-2 grid-details" *ngFor="let corTrg of trgList; let i = index">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{corTrg.corTrgCode}}">
                    <h6 class="mb-lg-0 text-truncate"> {{corTrg.corTrgCode}} </h6>
                </div>
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="{{corTrg.name}}">
                    <h6 class="mb-lg-0 text-truncate"> {{corTrg.name}} </h6>
                </div>
                <!-- <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center">
                    <h6 class="mb-lg-0" ngbtooltip="Click for more options" ng-reflect-ngb-tooltip="Click for more options">
                        <i class="fa fa-ellipsis-h" [id]="corTrg.id" (click)=entityOps($event)></i>
                    </h6>
                    <div class="empActions m-t-nsmd" *ngIf="selectedCorTrgId==corTrg.id?true:false">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="editCorTarget(corTrg)">
                                <i class="fa fa-pencil mr-2"></i>Edit
                            </li>
                            <li (click)="removeCorTrg(corTrg)">
                                <i class="fa fa-trash mr-2"></i>Delete
                            </li>
                        </ul>
                    </div>
                </div> -->
                <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left text-center" [id]="corTrg.id"
                     (mouseenter)=entityOps($event)
                     (mouseleave)=closeDropDown($event)>
                    <h6 class="mb-lg-0">
                        <i class="fa fa-ellipsis-h"></i>
                    </h6>
                    <div class="empActions m-t-nsmd" style="top:29px" *ngIf="selectedCorTrgId==corTrg.id?true:false">
                        <i class="fa fa-caret-up caret-up"></i>
                        <ul class="m-0 p-0">
                            <li (click)="editCorTarget(corTrg)">
                                <i class="fa fa-pencil mr-2"></i>Edit
                            </li>
                            <li (click)="removeCorTrg(corTrg)">
                                <i class="fa fa-trash mr-2"></i>Delete
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <ng-container *ngIf="trgList.length == 0">
                <div class="w-100 float-left p-4 grid-details" *ngIf="!loader">
                    <p class="text-center m-0 w-100 medium">No Results Found</p>
                </div>
            </ng-container>


            <!-- PAGINATION FOR MAIN-PAGE-->
            <div class="w-100 float-left my-4 light-bg p-3 align-v-center">
                <h6 class="float-left mb-0 mr-4 text-truncate"> {{startingPage}} - {{endingPage}} of {{totalCorTrgs}}
                    items </h6>
                <div class="float-left ml-2 align-v-center">
                    <label class="m-0 float-left">Show items per page</label>
                    <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="pageSize"
                            (change)="OnPageSizeChanged($event)">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                    </select>
                </div>
                <div style="flex-grow: 1;"></div>
                <ngb-pagination *ngIf='trgList.length' [collectionSize]="totalCorTrgs" [rotate]="true" [maxSize]="5"
                                [pageSize]="pageSize"
                                [ellipses]="false" [boundaryLinks]="true" [(page)]="currentPage"
                                (pageChange)="onPageChange($event)" class="float-right"></ngb-pagination>
            </div>

            <!-- Bulk Upload Summary-->
            <div class='info' *ngIf='uploadSucess'>
                <div class='col-lg-6 col-md-6 left-clear'>
                    <label>
                        <h5 class="medium m-0">Bulk Upload Summary</h5>
                    </label>
                </div>
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                                <h6 class="mb-lg-0 medium"> UPLOADED DATA </h6>
                            </div> -->
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left" ngbTooltip="NON EXISTENT TARGETS">
                        <h6 class="mb-lg-0 medium text-truncate"> NON EXISTENT TARGETS </h6>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"
                         *ngFor="let data of nonExistentDimensions, let ind = index "
                         ngbTooltip="NON EXISTENT DIMENSIONS {{ind + 1}}">
                        <h6 class="mb-lg-0 medium text-truncate"> NON EXISTENT DIMENSIONS {{ind + 1}}</h6>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                         *ngFor="let data of nonExistentDimLevels, let ind = index"
                         ngbTooltip="NON EXISTENT DIMENSION LEVELS {{ind + 1}}">
                        <h6 class="mb-lg-0 medium text-truncate"> NON EXISTENT DIMENSION LEVELS {{ind + 1}}</h6>
                    </div>
                </div>
                <div class="light-bg w-100 float-left p-2 grid-details">
                    <!-- <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                                <ul>
                                    <li *ngFor="let paData of uploadedDataList"> ID : {{paData}}</li>
                                </ul>
                            </div> -->
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left">
                        <ul>
                            <li *ngFor="let data of nonExistentTargets" ngbTooltip="{{data}}">{{data}}</li>
                        </ul>
                    </div>
                    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1 float-left"
                         *ngFor="let data of nonExistentDimensions">
                        <ul>
                            <li *ngFor="let i of data" ngbTooltip="{{i}}">{{i}}</li>
                        </ul>
                    </div>
                    <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left"
                         *ngFor="let data of nonExistentDimLevels">
                        <ul>
                            <li *ngFor="let i of data" ngbTooltip="{{i}}">{{i}}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 pull-left mt-3">
                    <button id="onCloseSummary" type="submit" class="float-right btn btn-primary"
                            (click)="onCloseSummary($event)">Close Summary
                    </button>
                </div>
            </div>
        </div>

        <!--ADDING OR UPDATING TARGETS-->
        <div *ngIf='trgPage'>
            <div class="b-b pb-2 w-100 mb-3 float-left align-v-center">
                <h5 class="medium m-0" *ngIf="!isEdit">Add Cor Target </h5>
                <h5 class="medium m-0" *ngIf="isEdit">Edit Cor Target - {{corTrgData.corTrgCode}}</h5>
                <div class="ml-alert"></div>
                <div style="flex-grow: 1;"></div>
                <button class="btn btn-secondary" (click)="onBack()">
                    <i class="fa fa-arrow-left mr-sm-2"></i> Back
                </button>
            </div>
            <div class="w-100 float-left mt-3">
                <div [ngClass]="!isEdit ? 'col-lg-6 col-md-6 left-clear' : 'col-lg-6 col-md-6 float-left'">
                    <div class="form-group">
                        <label> Name
                            <span class="text-danger medium">*</span>
                        </label>
                        <input maxlength="200" type="text" class="form-control" [(ngModel)]="corTrgData.name"
                               name="name"/>
                    </div>
                </div>
                <div class="col-lg-1 col-md-1 float-left left-clear">
                    <button class="btn btn-primary float-left" [disabled]="saveButton" (click)="onSave()">Save</button>
                </div>
                <ng-container *ngIf="isEdit">
                    <div class="col-lg-2 col-md-2 float-left">
                        <button id="addMasTrg" (click)="addMasTarget(corTrgData)" class=" btn btn-primary float-left">
                            Add Mas Targets
                        </button>
                    </div>
                    <div class="w-100 float-left mt-3">
                        <h5 class="mb-lg-0 medium" *ngIf=" corMasTrgList.length > 0 ">
                            <label>Mas Targets</label>
                        </h5>
                        <div class="light-bg w-100 float-left p-2 grid-details" *ngIf=" corMasTrgList.length > 0 ">
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left" ngbTooltip="Target Date">
                                <h6 class="mb-lg-0 medium text-truncate"> Target Date </h6>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Target Value">
                                <h6 class="mb-lg-0 medium text-truncate">
                                    Target Value
                                </h6>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left" ngbTooltip="Mas-Target Actions">
                                <h6 class="mb-lg-0 medium text-truncate">
                                    Mas-Target Actions
                                </h6>
                            </div>
                            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 float-left" ngbTooltip="Det-Target Details">
                                <h6 class="mb-lg-0 medium">
                                    Det-Targets Details
                                </h6>
                            </div>
                        </div>

                        <div class="w-100 float-left p-md-2 grid-details table-custom"
                             *ngFor="let corMasTrg of corMasTrgList; let i = index">
                            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                                <!-- <h5 class="mb-lg-0 text-truncate"> -->
                                <!--
                                        <input class="w-full p-sm b-a" placeholder="YYYYMMDD" name="targetDate" ngbDatepicker (ngModelChange)="onDateChange($event,i)"
                                            [(ngModel)]="corMasTrg.date" #d="ngbDatepicker" readonly>
                                        <button class="iga-left" (click)="d.toggle()" type="button">
                                            <i class="fa fa-calendar"></i>
                                        </button>
                                        -->
                                <!--<input type="number" [(ngModel)]="corMasTrg.date" class="w-full p-sm b-a" placeholder="yyyymmdd" />-->
                                <!-- <input type="date" *ngIf='datePickerList[i]' (change)="onDateChange($event,i)" required class="w-full p-sm b-a" placeholder="yyyymmdd"
                                />
                            </h5>
                            <div class="selectedItem" *ngIf='!datePickerList[i]'>
                                <h5 class="mb-lg-0 text-truncate">{{corMasTrg.date}}
                                    <i class="fa fa-close mr-2" (click)='removeSelectedDate(i)'></i>
                                </h5>
                            </div> -->
                                <div class='col-sx-8 float-left left-clear'>
                                    <input class="form-control light-bg" placeholder="YYYYMMDD" name="targetDate"
                                           ngbDatepicker [(ngModel)]="corMasTrg.date"
                                           #d="ngbDatepicker" readonly>
                                </div>
                                <div class="col-sx-1 float-left">
                                    <button class="iga-left form-control light-bg" (click)="d.toggle()" type="button">
                                        <i class="fa fa-calendar"></i>
                                    </button>
                                </div>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                <input type="number" [(ngModel)]="corMasTrg.value" class="w-full p-sm b-a"
                                       placeholder="Target Value"/>
                            </div>
                            <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 float-left">
                                <h5 class="mb-lg-0">
                                    <i class="fa fa-plus mr-2 float-left" [attr.id]="i" (click)="addDetTarget(i)"
                                       id=" insert "> Add Det-Target </i>
                                    <i class="fa fa-trash mr-2 float-left" [attr.id]="i"
                                       (click)="removeMasTarget(corMasTrg)" id=" delete "> Delete </i>
                                </h5>
                            </div>
                            <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 float-left accordionss">
                                <ngb-accordion class="w-100">
                                    <ngb-panel id="corMasTrg.id" title="View-Dimensions">
                                        <ng-template ngbPanelContent>
                                            <div *ngFor="let corDetTrg of corDetTrgList[i] , let j = index">
                                                <div class="w-100 float-left p-md-2 grid-details table-custom">
                                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-4 float-left"
                                                         *ngIf="corDetTrg.id==null">

                                                        <h5 class="mb-lg-0" *ngIf="searchBarVisibility(i,j)">
                                                            <input id='dimSearch' placeholder="Dimension Level"
                                                                   #autoCompletediv auto-complete autocomplete="off"
                                                                   [source]="searchDim.bind(this)"
                                                                   [list-formatter]="autoCompleteListFormatter"
                                                                   [value-formatter]="orgNameValueFormatter"
                                                                   (valueChanged)="onSelectDim($event,corDetTrg,i,j)"
                                                                   [accept-user-input]='true'
                                                                   class="flex-grow:1 drop-down form-control"/>
                                                        </h5>

                                                        <div class="selectedItem" *ngIf="!searchBarVisibility(i,j)">
                                                            {{dimLvlList[i][j]}}
                                                            <i class="fa fa-close mr-2"
                                                               (click)='removeSelectedDim(i,j)'></i>
                                                        </div>
                                                    </div>
                                                    <div class="col-lg-5 col-md-5 col-sm-5 col-xs-5 float-left">
                                                        <h5 class="mb-lg-0 text-truncate">
                                                            <input type="text" [(ngModel)]="corDetTrg.dimLvlValue"
                                                                   class="w-full p-sm b-a"
                                                                   placeholder="Dimension Level Value"/>
                                                        </h5>
                                                    </div>
                                                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3 float-left">
                                                        <h5 class="mb-lg-0 text-truncate">
                                                            <i class="fa fa-trash mr-2 iga-left" [attr.id]="i"
                                                               [attr.value]="j" (click)="removeDetTarget(corDetTrg,i)"
                                                               id=" delete ">
                                                                Delete </i>
                                                        </h5>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </ngb-panel>
                                </ngb-accordion>
                            </div>

                        </div>

                    </div>
                    <ng-container *ngIf="corMasTrgList.length == 0">
                        <div class="w-100 float-left p-4 grid-details" *ngIf="!loader">
                            <p class="text-center m-0 w-100 medium">No Mas Targets Found</p>
                        </div>
                    </ng-container>

                    <!-- PAGINATION FOR TARGET PAGE -->
                    <div class="w-100 float-left my-4 light-bg p-3 align-v-center" *ngIf="corMasTrgList.length > 0">
                        <h6 class="float-left mb-0 mr-4 text-truncate"> {{startingMPage}} - {{endingMPage}} of
                            {{totalMasTrgs}} items </h6>
                        <div class="float-left ml-2 align-v-center">
                            <label class="m-0 float-left">Show items per page</label>
                            <select class="form-control float-left w-auto ml-2 mb-0" [(ngModel)]="mSize"
                                    (change)="OnPageSizeChanged($event)">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                            </select>
                        </div>
                        <div style="flex-grow: 1;"></div>
                        <ngb-pagination *ngIf='corMasTrgList.length' [collectionSize]="totalMasTrgs" [rotate]="true"
                                        [maxSize]="5" [pageSize]="mSize"
                                        [ellipses]="false" [boundaryLinks]="true" [(page)]="currentMPage"
                                        (pageChange)="onPageChange($event)"
                                        class="float-right"></ngb-pagination>
                    </div>

                    <!-- TARGET TREE -->
                    <!--
                            <div class="w-100 float-left mt-3">
                                <label>
                                    <h5 class="medium m-0">Target Data</h5>
                                </label>
                                <tree-root [(nodes)]='nodes'>
                                    <ng-template #treeNodeTemplate let-node let-index="index">
                                        <span *ngIf='node.data.name'>{{ node.data.name }}</span>
                                        <span *ngIf='node.data.dateId'>{{ node.data.dateId }}</span>
                                        <span *ngIf='node.data.dmLvlValue'>{{ node.data.dmLvlValue }}</span>
                                        <span *ngIf='node.data.trgValue'> ( Target Value : {{ node.data.trgValue }} )</span>
                                    </ng-template>
                                </tree-root>
                            </div>
                            -->

                </ng-container>

            </div>
        </div>
    </div>
    <div class="w-100 min-h2 relative" *ngIf="loader">
        <loader></loader>
    </div>
</ng-container>

<!--                 <div class='col-lg-3 col-md-3 left-clear'>
                    <div class="form-group">
                        <label>
                            <h5 class="medium m-0">Select Date</h5>
                        </label>
                        <input class="form-control" placeholder="YYYYMMDD" name="targetDate" [(ngModel)]="trgDate" ngbDatepicker (ngModelChange)="onDateChange($event)"
                            #d="ngbDatepicker" readonly>
                        <button class="iga-right" (click)="d.toggle()" type="button">
                            <i class="fa fa-calendar"></i>
                        </button>
                    </div>
                </div>
                <div class='col-lg-6 col-md-6 left-clear'>
                    <div class="form-group">
                        <label>
                            <h5 class="medium m-0">Select Dimensions</h5>
                        </label>
                        <input id='dimSearch' #autoCompletediv auto-complete autocomplete="off" [source]="searchDim.bind(this)" [list-formatter]="autoCompleteListFormatter"
                            [value-formatter]="orgNameValueFormatter" (valueChanged)="onSelectDim($event)" [accept-user-input]='true'
                            class="form-control drop-down" />
                    </div>
                    <div class="selectedItem" *ngFor="let dimension of selectedDimList; let i = index">{{dimension.dimName}} ({{dimension.dimCode}})
                        <i class="fa fa-close mr-2" (click)='removeSelectedDim($event)'></i>
                    </div>
                </div>
                <div class="col-lg-1 col-md-1 left-clear">
                    <button class="btn btn-primary float-left" (click)='onTrgLoad($event)'> Load Targets</button>
                </div>
 -->

<!-- 
            <table border="1">
                <tbody>
                    <tr>
                        <td rowspan="4">D1-L1</td>
                        <td rowspan="2">D2-L1</td>
                        <td rowspan="1">D3-L1</td>
                        <td>Val</td>
                    </tr>
                    <tr>
                        <td rowspan="1">D3-L2</td>
                        <td>Val</td>
                    </tr>
                    <tr>
                        <td rowspan="2">D2-L2</td>
                        <td rowspan="1">D3-L1</td>
                        <td>Val</td>
                    </tr>
                    <tr>
                        <td rowspan="1">D3-L2</td>
                        <td>Val</td>
                    </tr>
                    <tr>
                        <td rowspan="4">D1-L2</td>
                        <td rowspan="2">D2-L1</td>
                        <td rowspan="1">D3-L1</td>
                        <td>Val</td>
                    </tr>
                    <tr>

                        <td rowspan="1">D3-L2</td>
                        <td>Val</td>
                    </tr>
                    <tr>
                        <td rowspan="2">D2-L2</td>
                        <td rowspan="1">D3-L1</td>
                        <td>Val</td>
                    </tr>
                    <tr>
                        <td rowspan="1">D3-L2</td>
                        <td>Val</td>
                    </tr>
                </tbody>
            </table> -->


// WEBPACK FOOTER //
// ./src/app/bi/admin/controller/target.component.html